export default __webpack_public_path__ + "static/media/DSC_7516.c03f77de.jpg";